<template>
    <div :style="!$kmsTheme ? null : $kmsTheme.styles.logo" class="header-images">
        <img v-for="picture in pictures" :src="$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + picture.noticePictureId + '&type=' + picture.type" style="height:100%" />
    </div>
</template>

<script>
    import Vue from 'vue';
    

    export default {
        data() {
            return {
                
            }
        },
        props: {
            pictures: {

            }
        }
    }
</script>
<style>
    

    .header-images {
        height: calc(100px - 1rem) !important;
        margin: 0.5rem;
    }

    @media only screen and (min-width: 1000px) and (orientation:portrait), screen and (min-width:1500px) and (orientation:landscape) {
        .header-images {
            height: calc(117px - 1rem) !important;
        }       
    }
</style>
